<template>
<div id="app-header" v-if="header_type != '/login'">
    <div class="header-wrap">
        <div class="top-menu-bar">
            <!-- <div class="menu">
                    <a href="#">
                        <img src="../assets/images/mainIcon01.png" alt="icon-menu">
                    </a>
                </div> -->
            <h1 class="logo">
                <a @click="go_home">
                    <img src="../assets/images/logo.png" alt="logo">
                </a>
            </h1>
            <div class="mypage">
                <a v-if="!login_yn" @click="go_mypage(0)">
                    <img src="../assets/images/login.png" alt="login" class="header-login">
                </a>
                <a v-else @click="go_mypage(1)">
                    <img src="../assets/images/my.png" alt="mypage">
                </a>
            </div>
            <div class="bottom-radius" v-if="header_type != '/detail'"></div>
        </div>

        <div class="info-top-bar" v-if="header_type == '/detail' || header_type == '/map'">
            <div class="btn-back">

                <a href="javascript:void(0);" @click="goBackPage">
                    <img src="../assets/images/back.png" alt="back">
                </a>
            </div>
            <h2 class="info-top-title">
                {{store_data.store_name}}
            </h2>
        </div>

        <app-search v-if="header_type != '/detail' || header_type != '/map'" ref="search" />
    </div>
</div>
</template>

<script>
import AppSearch from './AppSearch.vue';
import EventBus from '../js/event_bus';

export default {
    name: 'AppHeader',
    components: {
        'app-search': AppSearch
    },
    data() {
        return {
            store_data: this.$store.getters['getParams'],
            header_type: this.$store.getters['getCurrentPage'].value,
            login_yn: false
        }
    },
    created() {
        EventBus.$on('detail-data', (data) => {
            this.store_data = data;
            if (this.store_data.store_id != 'undefined' && this.store_data.store_name != 'undefined') {
                this.header_type = '/detail';
            }
        });
    },
    methods: {
        goBackPage() {
            this.$router.push(this.$store.getters['getLastPage'].value);
        },
        go_mypage(val) {
            if (val == 0) {
                if (this.$router.history.current.fullPath != '/login') {
                    this.$router.push('/login');
                }
            } else if (val == 1) {
                if (this.$router.history.current.fullPath != '/mypage') {
                    this.$router.push('/mypage');
                }
            }

        },
        go_home() {
            if (this.$router.history.current.fullPath != '/') {
                EventBus.$emit('search-init-data', '');
                this.$router.push('/');
            }
        }
    },
    computed: {
        getCurrentPage() {
            return this.$store.getters.getCurrentPage.value;
        },
        getLogin_chk() {
            return this.$store.getters['getLogin_chk'].value;
        }
    },
    watch: {
        getCurrentPage() {
            this.header_type = this.$store.getters['getCurrentPage'].value;
        },
        getLogin_chk() {
            this.login_yn = this.$store.getters['getLogin_chk'].value;
        }
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/AppHeader.vue